import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Circle, Target } from "lucide-react";
import { Loading } from "@/pages/_shared";
import api from "@/lib/api";

const STATUS_STYLE = {
  Completed: "bg-emerald-50 text-emerald-700",
  Running: "bg-blue-50 text-blue-700",
  Queued: "bg-slate-100 text-slate-600",
  "Waiting for Approval": "bg-amber-50 text-amber-700",
  Blocked: "bg-orange-50 text-orange-700",
  Failed: "bg-red-50 text-red-600",
};

export default function Missions() {
  const [missions, setMissions] = useState(null);
  useEffect(() => { api.get("/missions").then(({ data }) => setMissions(data.missions)).catch(() => setMissions([])); }, []);
  if (!missions) return <Loading />;
  return (
    <div className="animate-fade-up" data-testid="missions-page">
      <h1 className="font-head text-2xl font-extrabold tracking-tight text-slate-900">Missions</h1>
      <p className="mt-1 text-[13px] text-slate-500">Every instruction you give becomes a coordinated mission. {missions.length} total.</p>
      {missions.length === 0 ? (
        <div className="mt-6 rounded-2xl border border-dashed border-slate-200 bg-white py-16 text-center text-[13px] text-slate-400">
          No missions yet. Open the Command Center and tell your Capital Crew what to do.
        </div>
      ) : (
        <div className="mt-5 space-y-3">
          {missions.map((m) => (
            <Link to={`/owner/missions/${m.id}`} key={m.id} className="block rounded-2xl border border-slate-200 bg-white p-5 transition-colors hover:border-slate-300" data-testid="mission-card">
              <div className="flex items-start justify-between gap-3">
                <div className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#1a5fd0]/10 text-[#1a5fd0]"><Target size={17} /></span>
                  <div>
                    <div className="font-head text-[15px] font-bold text-slate-900">{m.title}</div>
                    <div className="mt-1 flex flex-wrap gap-1">
                      {(m.assignees || []).map((a) => <span key={a} className="rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-semibold text-slate-600">{a}</span>)}
                    </div>
                  </div>
                </div>
                <span className={`shrink-0 rounded-full px-2.5 py-1 font-mono text-[9px] font-bold uppercase tracking-wider ${STATUS_STYLE[m.status] || "bg-slate-100 text-slate-600"}`}>{m.status}</span>
              </div>
              <div className="mt-4 flex flex-wrap gap-x-5 gap-y-2">
                {(m.steps || []).map((s, i) => (
                  <div key={i} className="flex items-center gap-1.5 text-[12px]">
                    {s.done ? <CheckCircle2 size={14} className="text-emerald-500" /> : <Circle size={14} className="text-slate-300" />}
                    <span className={s.done ? "text-slate-700" : "text-slate-400"}>{s.label}</span>
                  </div>
                ))}
              </div>
              <div className="mt-3 flex items-center justify-between">
                <span className="font-mono text-[10px] text-slate-400">Opened {String(m.when).slice(0, 10)}</span>
                <span className="text-[12px] font-semibold text-[#1a5fd0]">Open mission →</span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
